__turbopack_context__.v({
  "ada-chatbot-btn": "Chatbot-module-scss-module__9czD8q__ada-chatbot-btn",
});
